// extracted by mini-css-extract-plugin
export var layoutContainer = "_3y-0";
export var layoutContainerOpen = "_3y-3";
export var mainContent = "_3y-1";
export var panelLarge = "_3y-6";
export var panelMedium = "_3y-5";
export var panelSmall = "_3y-4";
export var slidePanel = "_3y-2";